module.exports = __webpack_public_path__ + "img/website.377af04f.png";